import React from 'react'
import { TableCol } from './TableCol'

import column from './interface'

interface TableHeadRowProps {
  columns: column[]
}

export const TableHeadRow: React.FC<TableHeadRowProps> = ({ columns }) => {
  return (
    <thead>
      <tr>
        {columns.map(col => (
          <TableCol key={col.field} column={col} />
        ))}
      </tr>
    </thead>
  )
}
